import { lazy } from 'react';

// eslint-disable-next-line import/extensions
const RequestLayout = lazy(() => import('../../components/Layout2/RequestLayout'));
// eslint-disable-next-line import/extensions
const ContentLayout = lazy(() => import('../../components/layout/ContentLayout'));
// eslint-disable-next-line import/extensions
const CommandOrder = lazy(() => import('./CommandOrder'));
// eslint-disable-next-line import/extensions
const CommandShowDocument = lazy(() => import('../CommandAll/CommandShowDocument'));
const roles = localStorage.getItem('user_role');
// eslint-disable-next-line import/extensions

const CommandOrderConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  // auth: authRoles.admin,
  auth: roles ? JSON.parse(roles) : [],
  routes: [
    {
      path: '/lawyer/request/order',
      element: (
        <RequestLayout requestType="ORDER">
          <CommandOrder />
        </RequestLayout>
      ),
    },
    {
      path: '/lawyer/request/order/:documentId',
      element: (
        <RequestLayout requestType="ORDER">
          <>
            <CommandOrder />
            <CommandShowDocument />
          </>
        </RequestLayout>
      ),
    },
  ],
};

export default CommandOrderConfig;
